/**
 * Indicates the distance on the left side from the parent's container if the tab is active.
 * @type {number}
 */
export const activeTabLeft = '--active-tab-left';
/**
 * Indicates the distance on the right side from the parent's container if the tab is active.
 * @type {number}
 */
export const activeTabRight = '--active-tab-right';
/**
 * Indicates the distance on the top side from the parent's container if the tab is active.
 * @type {number}
 */
export const activeTabTop = '--active-tab-top';
/**
 * Indicates the distance on the bottom side from the parent's container if the tab is active.
 * @type {number}
 */
export const activeTabBottom = '--active-tab-bottom';
/**
 * Indicates the width of the tab if it is active.
 * @type {number}
 */
export const activeTabWidth = '--active-tab-width';
/**
 * Indicates the height of the tab if it is active.
 * @type {number}
 */
export const activeTabHeight = '--active-tab-height';